export const goToContactCard = (contactId: number) => {
	Tools.$state.go('contact.dashboard', { id: contactId });
};

export const getContactCardHref = (contactId: number) => {
	return Tools.$state.href('contact.dashboard', {
		customerId: Tools.AppService.getCustomerId(),
		id: contactId
	});
};
